// extracted by mini-css-extract-plugin
export var button = "footerMenu-module--button--5b325";
export var footer_nav = "footerMenu-module--footer_nav--03803";
export var footer_nav_wrapper = "footerMenu-module--footer_nav_wrapper--e1a8d";
export var navbar = "footerMenu-module--navbar--22717";
export var submenu = "footerMenu-module--submenu--1e4ea";